export const reservedTeamSlugs = [
  'dashboard',
  'new',
  'news',
  'create',
  'account',
  'settings',
  'blog',
  'about',
  'about-us',
  'docs',
  'templates',
  'documentation',
  'features',
  'use-cases',
  'product',
  'sitemaps',
  'ai',
  'api-explorer',
  'home',
  'index',
  'changelog',
  'login',
  'logout',
  'signup',
  'signin',
  'api',
  'help',
  'support',
  'auth',
  'sotano-kit',
  'explore',
  'integrations',
  'marketplace',
  'contact',
  'pricing',
  'enterprise',
  'events',
  'billing',
  'contact-us',
  'careers',
  'join',
  'jobs',
  'newsroom',
  'partners',
  'onboarding',
  'manifesto',
  'underground',
  'monitoring',
  'security',
  'avatar',
  'privacy',
  'privacy-policy',
  'terms',
  'terms-of-service',
  'terms-and-conditions',
  'legal',
  'newsletter',
  'maintenance',
  'admin',
  'ghost',
  'api-token',
  '_static',
  'pump',
  'public',
  'private',
  'vs',
  'START',
  'start',
]

export const reservedRepoSlugs = ['settings', 'integrations']
